<template>
  <b-modal
    size="lg"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div>
            <span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-row>
        <b-col cols="12">
          <b-form-group>
            <lg-form-input
              id="dias-input"
              v-model.number="form.dias"
              type="number"
              label="Dias:"
              min="0"
              required
              placeholder="Digite o número de dias"
            />
          </b-form-group>
        </b-col>

        <!-- Campo Frequência -->
        <b-col cols="12">
          <b-form-group>
            <lg-form-select
              v-model="form.frequencia"
              :loadFunction="loadFrequenciaList"
              labelFormGroupBind="Frequência:"
              label="descricao"
              :description="''"
              :filterList="false"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Campo Prazo no Patrimônio -->
        <b-col cols="12">
          <b-form-group>
            <lg-form-input
              id="prazo-patrimonio-input"
              v-model.number="form.prazoPatrimonio"
              type="number"
              label="Prazo no Patrimônio:"
              min="0"
              required
              placeholder="Digite o prazo no patrimônio"
            />
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import { FREQUENCIA_OPTIONS } from "@/constants/frequencyOptions";

export default {
  components: {
    LgFormInput,
    LgFormSelect,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        dias: 0,
        frequencia: null, // Deve armazenar apenas o código numérico
        prazoPatrimonio: 0, // Prazo no patrimônio
      },
      frequenciasOptions: FREQUENCIA_OPTIONS, // Importa as opções mapeadas
    };
  },
  methods: {
    async loadFrequenciaList() {
      return {
        data: {
          content: this.frequenciasOptions,
          totalPages: 1
        }
      };
    },
    async salvar() {

      if (
        this.form.dias === null ||
        this.form.frequencia === null ||
        this.form.prazoPatrimonio === null
      ) {
        this.$bvToast.toast("Preencha todos os campos obrigatórios", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const valorPropriedade = [
        this.form.dias,
        this.form.frequencia.value,
        this.form.prazoPatrimonio,
      ].join(";");

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },

    cancelar() {
      this.$emit("close");
    },

    carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        const valores = this.configuracao.valorPropriedade.split(";");
        this.form.dias = parseInt(valores[0], 10) || 0;
        this.form.frequencia = FREQUENCIA_OPTIONS.find(f=> f.value == parseInt(valores[1], 10))|| null; 
        this.form.prazoPatrimonio = parseInt(valores[2], 10) || 0;
      }
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
